// src/components/Maintenance.js
import React from 'react';
import VelvetLogo from '../icons/VL_WordmarkOnly_Light.svg';
import '../styles/Maintenance.css';

const Maintenance = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <img src={VelvetLogo} alt="Velvet" className="maintenance-logo" />
        <h1>We'll Be Right Back</h1>
        <p className="maintenance-message">Velvet is currently down for maintenance</p>

        <div className="maintenance-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            <path d="M12 8v4"></path>
            <path d="M12 16h.01"></path>
          </svg>
        </div>

        <p className="maintenance-description">
          We're performing scheduled maintenance to improve your experience.
          We'll be back online shortly.
        </p>

        <p className="maintenance-footer-text">Thank you for your patience</p>
      </div>
    </div>
  );
};

export default Maintenance;
